import Expand from "@arcgis/core/widgets/Expand";
import { addBaseMapToggle } from "../../components/BaseMapToggle/BaseMapToggle";
import { HomeWidget } from "../../components/homeViewModel/HomeViewModel";
import { initLegend } from "../../components/Legend/Legend";
import { initLocate } from "../../components/locator/Locator";
import { Measurement } from "../../components/measurementViewModel/MeasurementViewModel";
import { loadSearchViewModule } from "../../components/searchViewModel/SearchViewModel";
import { initSketchViewModel } from "../../components/sketchViewModel/SketchViewModel";
import { CoordinateConversionImp } from "../../components/CoordinateConversion/CoordinateConversion";
import { createSearch } from '../../components/Search';
/**
 * @category esri widgets
 * @example
 * ```typescript
 * let widgetSettings = {
            mapview: mapView,
            wedgitPosition: "top-right",
            expandTooltip: 'بحث فى الامانات والبلديات',
            content: document.getElementById(''),
            expandIconClass: 'esri-icon-search',
            expanded: true
         }
       momraGisCore.createWidget(widgetSettings);
 * ```
 * */
export function createWidget(expandWidget) {
    const expand = new Expand({
        expandTooltip: expandWidget.expandTooltip,
        view: expandWidget.mapview,
        content: expandWidget.content,
        expanded: expandWidget.expanded,
        expandIconClass: expandWidget.expandIconClass
    });
    expandWidget.mapview.ui.add(expand, expandWidget.wedgitPosition);
}
/**@category esri widgets */
export function searchWidget(settings) {
    createSearch(settings);
}
/**@category esri widgets */
export function Legend(settings) {
    return initLegend(settings);
}
/**@category esri widgets */
export function searchViewModel(mapView) {
    return loadSearchViewModule(mapView);
}
/**
 * @category esri widgets
 * @example
 * ```typescript
 *let mapToggle = {
                mapView: mapView,
                esriBaseMapType: 'satellite',   // type for next basemap
                basemapPosition: 'bottom-left',
                toggled: true,   // toggles to the next basemap.
                callbackWhenToggled: mapToggleRespones
            }
            momraGisCore.mapToggled(mapToggle);

            function mapToggleRespones(event) {
                console.log(event);
            }
 * ```
*/
export function mapToggled(baseMapSettings) {
    addBaseMapToggle(baseMapSettings);
}
/**@category esri widgets */
export function createLocate(mapView, position) {
    return initLocate(mapView, position);
}
/**
 * @category esri widgets
 * @example
 * ```typescript
 *
 *  const pointSymbol = {
                    type: "simple-marker",
                    style: "circle",
                    size: 10,
                    color: [255, 255, 255, 0.8],
                    outline: {
                        color: [211, 132, 80, 0.7],
                        size: 10
                    }
            }

            const polygonSymbol = {
                    type: "simple-fill",
                    color: [150, 150, 150, 0.2],
                    outline: {
                        color: [50, 50, 50],
                        width: 2
                    }
            }

              const polylineSymbol = {
                    type: "simple-line",
                    color: [130, 130, 130],
                    width: 2
            }
            
 * let drawSettings = {
                    mapView: mapView,
                    callbackWhenDone: sketchRespones,
                    mapContainerId: 'view',
                    snappingOptions: false,
                    pointSymbol: pointSymbol,
                    polygonSymbol: polygonSymbol,
                    polylineSymbol: polylineSymbol,
                    controlPosition: "top-right",
                    clear: false,
                    availableTools: ['point', 'polyline', 'polygon'], // ['point','polyline','polygon']
                    updateOnGraphicClick: true
            }

                momraGisCore.drawingOnMap(drawSettings)
   
            //to get respones when complete drawing
            function sketchRespones(respones) {
                console.log(respones);
            }
 * ```
*/
export function drawingOnMap(settings) {
    initSketchViewModel({
        mapView: settings.mapView,
        callbackWhenDone: settings.callbackWhenDone,
        mapContainerId: settings.mapContainerId,
        pointSymbol: settings.pointSymbol,
        polygonSymbol: settings.polygonSymbol,
        polylineSymbol: settings.polylineSymbol,
        controlPosition: settings.controlPosition,
        clear: settings.clear,
        availableTools: settings.availableTools,
        snappingOptions: settings.snappingOptions
    });
}
/**@category esri widgets */
export function MeasurementTools(settings) {
    return Measurement(settings);
}
/**
 * @category esri widgets
 * @example
 * ```typescript
 * let homeSettings = {
 * view: mapView,
 * widgetPosition: "top-left"
 * }
 * momraGisCore.Home(homeSettings);
 * ```
 * @property view  - you will pass the mapView object for this property
 * @property widgetPosition - string value with the following ("top-left", "top-right", "bottom-left", "bottom-right") to control widget position
 */
export function Home(settings) {
    HomeWidget(settings);
}
/**
 * @category esri widgets
 * @version 1.0.4 and above
*/
export function coordinateConversWidget(settings) {
    CoordinateConversionImp(settings);
}
